import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "native", "slotProps", "helperText", "inputProps", "InputLabelProps", "options", "placeholder"];
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import stl from "./RHFSelect.module.css";
import { useTranslation } from "@i18n";
export function RHFSelect(_ref) {
  var name = _ref.name,
    _native = _ref["native"],
    slotProps = _ref.slotProps,
    helperText = _ref.helperText,
    inputProps = _ref.inputProps,
    InputLabelProps = _ref.InputLabelProps,
    options = _ref.options,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var labelId = "".concat(name, "-select-label");
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(stl.selectWrapper, " ").concat(isFocused ? stl.focused : "", " ").concat(error ? stl.hasError : "")
      }, /*#__PURE__*/React.createElement("select", _extends({}, field, {
        className: !field.value ? stl.empty : "",
        name: name,
        value: field.value,
        placeholder: placeholder,
        onChange: function onChange(e) {
          field.onChange(e);
          setIsFocused(true);
        },
        onClick: function onClick() {
          return setIsFocused(true);
        },
        onFocus: function onFocus() {
          return setIsFocused(true);
        },
        onBlur: function onBlur() {
          return setIsFocused(false);
        },
        autoFocus: other.autoFocus,
        disabled: other.disabled
      }, inputProps), !field.value && /*#__PURE__*/React.createElement("option", {
        className: stl.selectPlaceholder,
        value: "",
        disabled: true
      }, placeholder), options.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          key: option.id,
          value: option.id
        }, option.label);
      })), /*#__PURE__*/React.createElement("i", {
        className: stl.arrIcon
      }), helperText && /*#__PURE__*/React.createElement("span", {
        className: stl.helperText
      }, helperText), error && /*#__PURE__*/React.createElement("span", {
        className: "errorText"
      }, tShort(error.message, {
        ns: "validations"
      })));
    }
  });
}